"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SortingArrowIcon(props) {
    if (props.direction) {
        //TODO: fix rotation
        var rotation = props.direction === 1 ? "translate(-4 -4)" : "rotate(180 6 6)";
        var colour = props.active ? "#0098db" : "#c4c8cc";
        return (React.createElement("svg", { id: "sorting-arrow-icon", width: "8", height: "8", viewBox: "0 0 8 8" },
            React.createElement("defs", null,
                React.createElement("polygon", { id: "sorting_arrow_-a", points: "4 0 0 3.953 3.256 3.953 3.256 8 4.756 8 4.756 3.953 8 3.953" })),
            React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "" + rotation },
                React.createElement("rect", { width: "16", height: "16", fill: "#FFF", fillRule: "nonzero", opacity: "0" }),
                React.createElement("polygon", { fill: "#898f94", fillRule: "nonzero", points: "8 4 4 7.953 7.256 7.953 7.256 12 8.756 12 8.756 7.953 12 7.953" }),
                React.createElement("g", { transform: "translate(4 4)" },
                    React.createElement("mask", { id: "sorting_arrow_-b", fill: "#fff" },
                        React.createElement("use", { href: "#sorting_arrow_-a" })),
                    React.createElement("g", { fill: colour, fillRule: "nonzero", mask: "url(#sorting_arrow_-b)" },
                        React.createElement("rect", { width: "24", height: "24", transform: "translate(-4 -8)" }))))));
    }
    else {
        return null;
    }
}
exports.SortingArrowIcon = SortingArrowIcon;
